import DocusaurusFooter from '../DocusaurusFooter'
import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import { daiWebhooks } from '../../docs-routes'

const WebhookHelp = () =>
  <Paragraph>
    <Color variant='theme-description-text'>
      You can use Webhooks to trigger a wide range of notifications when a test config run finishes.
      <br />
      <br />
      DAI Admins can create, view, and manage webhook profiles here.
      <br />
    </Color>
    <DocusaurusFooter path={daiWebhooks} />
  </Paragraph>

export default WebhookHelp
